import React, { lazy } from 'react';
const DefaultRoute = lazy(() => import(/* webpackChunkName: "default-route-page" */ './DefaultRoute'));
export const GlueDefaultRouteObject = [
    {
        path: '*',
        element: React.createElement(DefaultRoute, null),
    },
];
//# sourceMappingURL=Route.js.map